"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _transforms = require("@nteract/transforms");

var Fallback = function Fallback(_ref) {
  var componentStack = _ref.componentStack,
      error = _ref.error;
  return _react["default"].createElement("div", {
    style: {
      backgroundColor: "ghostwhite",
      color: "black",
      fontWeight: "600",
      display: "block",
      padding: "10px",
      marginBottom: "20px"
    }
  }, _react["default"].createElement("h3", null, " Error: ", error.toString()), _react["default"].createElement("details", null, _react["default"].createElement("summary", null, "stack trace"), _react["default"].createElement("pre", null, componentStack)));
};

var RichestMime = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(RichestMime, _React$Component);

  function RichestMime(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, RichestMime);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(RichestMime).call(this, props));
    _this.state = {
      error: null,
      info: null
    };
    return _this;
  }

  (0, _createClass2["default"])(RichestMime, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({
        error: error,
        info: info
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.error) {
        return _react["default"].createElement(Fallback, {
          componentStack: this.state.info ? this.state.info.componentStack : "",
          error: this.state.error
        });
      }

      var mimetype = (0, _transforms.richestMimetype)(this.props.bundle, this.props.displayOrder, this.props.transforms);

      if (!mimetype) {
        // If no mimetype is supported, don't return an element
        return null;
      }

      var Transform = this.props.transforms[mimetype];
      var data = this.props.bundle[mimetype];
      var metadata = this.props.metadata[mimetype];
      return _react["default"].createElement(Transform, {
        data: data,
        metadata: metadata,
        theme: this.props.theme,
        models: this.props.models,
        channels: this.props.channels
      });
    }
  }]);
  return RichestMime;
}(_react["default"].Component);

exports["default"] = RichestMime;
(0, _defineProperty2["default"])(RichestMime, "defaultProps", {
  transforms: _transforms.transforms,
  displayOrder: _transforms.displayOrder,
  theme: "light",
  metadata: {},
  bundle: {},
  models: {}
});